import styles from "./Grid.module.scss";
import classnames from "classnames/bind";
import { CharStatus } from "../statuses";
import { motion } from "framer-motion";
import { GameVisuals } from "../../../gql/graphql";

const cx = classnames.bind(styles);

type CellProps = {
  letter?: string;
  status?: CharStatus;
  theme: GameVisuals;
};

export const Cell = ({ letter, status, theme }: CellProps) => {
  const classes = cx("cell", {
    correct: status === "correct",
    present: status === "present",
    absent: status === "absent",
  });

  const backgroundColor = {
    correct: theme.correctLetter,
    present: theme.presentLetter,
    absent: theme.absentLetter,
    default: theme.defaultLetter,
  };

  return (
    <motion.div
      animate={{ scale: letter ? [1, 1.1, 1] : 1 }}
      transition={{ duration: 0.1 }}
      initial={false}
      className={classes}
      style={{ backgroundColor: backgroundColor[status || "default"] }}
    >
      {letter}
    </motion.div>
  );
};
